<template>
  <div
    class="full-size"
    :style="{ opacity: html ? 1 : 0.1 }"
    style="transition: opacity 1s"
  >
    <v-tabs
      v-model="tab"
      background-color="transparent"
      grow
      @change="tabChange"
    >
      <v-tab>Preview</v-tab>
      <v-tab>HTML</v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <iframe
            class="full-size"
            style="border:none;overflow: auto"
            id="email-preview-iframe"
          ></iframe>
        </v-tab-item>
        <v-tab-item>
          <textarea class="full-size" style="background: none" v-model="html" />
          <!--          <highlightjs autodetect :code="html" />-->
          <!--          <pre v-highlightjs="html"><code class="language-html"></code></pre>-->
          <!--          <highlight-code lang="javascript">-->
          <!--            let str = 'Hello, World!'; console.log(str);-->
          <!--          </highlight-code>-->
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import Hivue from "@/hive/Hivue";

export default {
  name: "EmailViewer",
  data() {
    return {
      tab: null
    };
  },
  props: {
    html: { type: String }
  },
  methods: {
    tabChange() {}
  },
  watch: {
    html: {
      immediate: true,
      handler(v) {
        // console.log(v);
        if (!v) {
          Hivue.writeHtmlToIframe("email-preview-iframe", "");
        } else {
          Hivue.writeHtmlToIframe("email-preview-iframe", v);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/fullHeightVTabs.scss";
</style>
